module.exports = __webpack_public_path__ + "static/img/101265.3ded2555.png";